import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import "./style.css";

interface Props {
  show: boolean;
  onAccept: () => void;
  loading?: boolean;
}

const TermsModal: React.FC<Props> = ({
  show,
  onAccept,
  loading = false,
}) => {
  const pdfUrl = "https://www.ebullion.in/terms-and-conditions/terms.html";

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      contentClassName="modern-terms-modal"
    >
      <Modal.Body className="modern-terms-body">

        <h2 className="modern-terms-title">
          Terms & Conditions
        </h2>

        <p className="modern-terms-text">
          Please take a moment to carefully read our <strong>Terms & Conditions</strong> before proceeding.
          By clicking <strong>“Accept”</strong>, you confirm that you have read, understood,
          and agree to comply with the Terms & Conditions governing the use of our
          platform and services.
        </p>

        <div className="modern-terms-link-section">
          <span className="modern-terms-link-label">
            You can review the complete document here:
          </span>

          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="modern-terms-link"
          >
            View Full Terms & Conditions
          </a>
        </div>

        <Button
          onClick={onAccept}
          disabled={loading}
          className="modern-terms-button"
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                className="me-2"
              />
              Processing...
            </>
          ) : (
            "Accept"
          )}
        </Button>

      </Modal.Body>
    </Modal>
  );
};

export default TermsModal;
